import React from 'react';

import FalconsFooterAdapter from './FalconsFooterAdapter';
import LandingFooterAdapter from './LandingFooterAdapter';
import LifeCareerBalanceFooterAdapter from './LifeCareerBalanceFooterAdapter';
import StandardFooterAdapter from './StandardFooterAdapter';

interface FooterProps {
  isCareersPage: boolean;
  isFalconsPage: boolean;
  isLcbPage: boolean;
  isLandingPage: boolean;
}

const FooterAdapter: React.FC<FooterProps> = ({
  isCareersPage,
  isFalconsPage,
  isLcbPage,
  isLandingPage,
}) => {
  if (isFalconsPage) {
    return <FalconsFooterAdapter />;
  } else if (isLandingPage) {
    return <LandingFooterAdapter />;
  } else if (isLcbPage) {
    return <LifeCareerBalanceFooterAdapter />;
  }
  return <StandardFooterAdapter isCareersPage={isCareersPage} />;
};

export default FooterAdapter;
